import React, { Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { BiChevronDown } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { HiMenuAlt3 } from "react-icons/hi";
import { AiOutlineClose, AiOutlineLogout } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomButton from "./CustomButton";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import axios from "axios";


function MenuList({ user, onClick }) {
  const [token, setToken] = useState("");
  const[role ,setRole]=useState('');
  const [companyData, setCompanyData] = useState(null);
  const checkRole = window.localStorage.getItem('role');
  const [userId ,setUserId] = useState('');
 
  useEffect(() => {
     const usertoken = window.localStorage.getItem("token");
     const userRole = window.localStorage.getItem('role');
     console.log(token);
  setRole(userRole);
  
     setToken(usertoken);
     const decoded = jwtDecode(usertoken, { secret: '123456' });
     console.log("Decoded token:", decoded);
     const userId = decoded.userId;
     setUserId(userId);
 
     const fetchData = async () => {
       try {
         const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/${checkRole === "company" ? "company/get-company" : "user/get-user"}/${userId}`);
         
         if(checkRole === "seeker")
         {
          setCompanyData('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmT8NDYBa8lcbCZGxqYrJ_3cP72hKdyzUsoQ&usqp=CAU')
          
         }
         else{
         setCompanyData(response.data.data.profileUrl);
         }
       } catch (error) {
         console.error('Error fetching data:', error);
       }
     };
 
     fetchData();
  }, [checkRole,token]);
  const handleLogout = () => {
    // Your logout logic here
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('isLogin');
    window.localStorage.removeItem('role');
    window.location.href = "/";
  };
  
  return (
    <div>
      <Menu as="div" className="inline-block text-left">
        <div className="flex">
          <Menu.Button className="inline-flex gap-2 w-full rounded-md bg-white md:px-4 py-2 text-sm font-medium text-slate-700 hover:bg-opacity-20 ">
            <div className="leading[80px] flex flex-col items-start">
              <p className="text-sm font-semibold ">
                {user?.firstName ?? user?.name}
              </p>
              <span className="text-sm text-blue-600 ">
                {user?.jobTitle ?? user?.email}
              </span>
            </div>

            <img
              src={companyData}
              alt="user profile"
              className="w-10 h-10 rounded-full object-cover "
            />
            <BiChevronDown
              className="h-8 w-8 text-slate-600"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute z-50 right-2 mt-2 w-56 origin-top-right divide-y dividfe-gray-100 rounded-md bg-white shadow-lg focus:outline-none ">
            <div className="p-1 ">
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to={`${role === "seeker" ? "user-profile" : `company-profile/${userId}`}`}
                    className={`${active ? "bg-blue-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md p-2 text-sm`}
                    onClick={onClick}
                  >
                    <CgProfile
                      className={`${active ? "text-white" : "text-gray-600"} mr-2 h-5 w-5  `}
                      aria-hidden="true"
                    />
                    {role === "seeker" ? "User Profile" : "Company Profile"}
                  </Link>
                )}
              </Menu.Item>

              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleLogout()}
                    className={`${active ? "bg-blue-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    <AiOutlineLogout
                      className={`${active ? "text-white" : "text-gray-600"} mr-2 h-5 w-5  `}
                      aria-hidden="true"
                    />
                    Log Out
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
const Navbar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const user = useSelector((state) => state.user);
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState("seeker"); // Initialize role state

  useEffect(() => {
    // Check if user is logged in from local storage
    const isUserLoggedIn = localStorage.getItem("isLogin") === "true";
    setIsLoggedIn(isUserLoggedIn);

    // Set role based on local storage
    const checkRole = localStorage.getItem('role');
    setRole(checkRole);
    console.log(checkRole);
  }, []);

  const handleCloseNavbar = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className="relative bg-[#f7fdfd] z-50">
        <nav className="container mx-auto flex items-center justify-between p-5">
          <div>
            <Link to="/" className="text-blue-600 font-bold text-xl">
              Job<span className="text-[#1677cccb]">Finder</span>
            </Link>
          </div>

          <ul className="hidden lg:flex gap-10 text-base">
            <li>
              <Link to="/">Find Job</Link>
            </li>
            <li>
              <Link to="/companies">Companies</Link>
            </li>
            {isLoggedIn && role === "company" && ( // Render if user is logged in and role is "company"
  <li>
    <Link to="/upload-job">Upload Job</Link>
  </li>
)}

            <li>
              <Link to="/about-us">About</Link>
            </li>
          </ul>

          <div className="hidden lg:block">
            {!isLoggedIn ? (
              <Link to="/user-auth">
                <CustomButton
                  title="Sign In"
                  containerStyles="text-blue-600 py-1.5 px-5 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-base border border-blue-600"
                />
              </Link>
            ) : (
              <div>
                <MenuList user={user} />
              </div>
            )}
          </div>

          <button
            className="block lg:hidden text-slate-900"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            {isOpen ? <AiOutlineClose size={26} /> : <HiMenuAlt3 size={26} />}
          </button>
        </nav>

        {/* MOBILE MENU */}
        <div
          className={`${
            isOpen ? "absolute flex bg-[#f7fdfd] " : "hidden"
          } container mx-auto lg:hidden flex-col pl-8 gap-3 py-5`}
        >
          <Link to="/" onClick={handleCloseNavbar}>
            Find Job
          </Link>
          <Link to="/companies" onClick={handleCloseNavbar}>
            Companies
          </Link>
          {isLoggedIn && role === "company" && ( // Render if user is logged in and role is "company"
  
    <Link to="/upload-job"  onClick={handleCloseNavbar}>Upload Job</Link>
  
)}
          <Link to="/about-us" onClick={handleCloseNavbar}>
            About
          </Link>

          <div className="w-full py-10">
            {!isLoggedIn ? (
              <a href="/user-auth">
                <CustomButton
                  title="Sign In"
                  containerStyles="text-blue-600 py-1.5 px-5 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-base border border-blue-600"
                />
              </a>
            ) : (
              <div>
                <MenuList user={user} onClick={handleCloseNavbar} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
